import { render, staticRenderFns } from "./GestionTurnos.vue?vue&type=template&id=77181dbe&scoped=true"
import script from "./GestionTurnos.vue?vue&type=script&lang=js"
export * from "./GestionTurnos.vue?vue&type=script&lang=js"
import style0 from "./GestionTurnos.vue?vue&type=style&index=0&id=77181dbe&prod&scoped=true&lang=scss"
import style1 from "./GestionTurnos.vue?vue&type=style&index=1&id=77181dbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77181dbe",
  null
  
)

export default component.exports